import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Validator from './index';
import './style/index.scss';
import { Form, FormRow, Label } from '../form/index';
import Input from '../input/index';
import { Radio, RadioGroup } from '../radio/index';
import Dropdown from '../dropdown/index';
import Datepicker from '../datepicker/index';
import Button from '../button/index';
import Message from '../message/index';
import { Playground, Props } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "validator"
    }}>{`Validator`}</h1>
    <p>{`Validator会遍历其所有层级的带有data-patterns属性的表单子元素，通过HOC的方式将其变得可校验化`}</p>

    <h3 {...{
      "id": "表单元素校验属性"
    }}>{`表单元素校验属性`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-patterns`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`校验模式，详见说明`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-trigger`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`校验时机，传入组件支持的事件prop`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string/array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`['onChange', 'onBlur']`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-checking`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`传入false关闭校验`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-required`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表单是否必填`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-required-msg`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`自定义必填时提示文案`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-tips`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`默认提示文案，info类型`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-placer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表单校验结果的回调，当此属性存在时，表单校验信息默认不展示`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-prefix`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表单校验化后，会被im-validator-enhancer包裹，可在表单前增加前缀元素`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data-suffix`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`表单校验化后，会被im-validator-enhancer包裹，可在表单后增加后缀元素`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "validator-apis"
    }}>{`Validator APIs`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`方法`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`checkField(val, name)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`手动触发某一表单元素的校验，当val为undefined时，Validator会尝试取得表单的当前值`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(val: `}<inlineCode parentName="td">{`any`}</inlineCode>{`, name: `}<inlineCode parentName="td">{`string`}</inlineCode>{`): `}<inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`scrollToErrorField(idx, offset)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`滚动到第`}<inlineCode parentName="td">{`idx`}</inlineCode>{`个错误的表单元素`}<strong parentName="td">{`(目前不支持offset参数)`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(idx: `}<inlineCode parentName="td">{`number`}</inlineCode>{`, offset: `}<inlineCode parentName="td">{`number`}</inlineCode>{`): `}<inlineCode parentName="td">{`bool`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isAllValid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`获取当前Validator下所有表单的是否全部通过校验`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(): `}<inlineCode parentName="td">{`bool`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isFieldValid(name)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`获取当前Validator下某个表单的校验值`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(): \`null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`resetField(name)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`重置当前Validator下某个表单的校验状态`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(): `}<inlineCode parentName="td">{`undefined`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "validator-props--methods"
    }}>{`Validator Props & Methods`}</h2>
    <Props of={Validator} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <Playground __position={1} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        isFree: true,\n        hasEndTime: 0,\n        canSubmit: false,\n      }\n      this.checkers = {\n        endFlag: (val, callback) => {\n          let isValid = true\n          let msg = \'\'\n          if (!this.state.isFree && val === 0) {\n            isValid = false\n            msg = \'付费课必须选择课程截止日期\'\n          }\n          callback({ isValid, msg })\n        },\n      }\n      this.handleTypeChange = this.handleTypeChange.bind(this)\n      this.handleFlagChange = this.handleFlagChange.bind(this)\n      this.toggleSubmit = this.toggleSubmit.bind(this)\n    }\n    handleTypeChange(val) {\n      this.setState(\n        {\n          isFree: val === 1,\n        },\n        () => {\n          return val === 1\n            ? this.validator.checkField(undefined, \'courseRight\')\n            : this.validator.checkField(undefined, \'coursePrice\')\n        },\n      )\n    }\n    handleFlagChange(val) {\n      this.setState(\n        {\n          hasEndTime: val === 1,\n        },\n        () => {\n          this.validator.checkField(undefined, \'courseEndTime\')\n        },\n      )\n    }\n    toggleSubmit(val) {\n      this.setState({\n        canSubmit: val,\n      })\n    }\n    render() {\n      return (\n        <Validator\n          ref={instance => {\n            this.validator = instance\n          }}\n          checkers={this.checkers}\n          onValid={() => this.toggleSubmit(true)}\n          onInValid={() => this.toggleSubmit(false)}\n        >\n          <Form horizontal={false}>\n            <FormRow>\n              <Label required>课程名称(使用内置校验模式)</Label>\n              <Input\n                name=\"courseName\"\n                placeholder=\"1-10个字\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'limit\',\n                    msg: \'须在1-10个字内\',\n                    limit: {\n                      min: 1,\n                      max: 10,\n                    },\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label required>课程类型(表单联动)</Label>\n              <RadioGroup\n                name=\"courseType\"\n                style={{ display: \'inline\' }}\n                defaultValue={1}\n                onChange={this.handleTypeChange}\n                data-required\n                data-patterns={[]}\n              >\n                <Radio value={1}>免费</Radio>\n                <Radio value={2}>收费</Radio>\n              </RadioGroup>\n            </FormRow>\n            {!this.state.isFree ? (\n              <FormRow>\n                <Label required>课程价格</Label>\n                <Input\n                  name=\"coursePrice\"\n                  placeholder=\"内置校验模式\"\n                  data-required\n                  data-patterns={[\n                    {\n                      key: \'range\',\n                      msg: \'须在1-8000元之间\',\n                      range: {\n                        min: 1,\n                        max: 8000,\n                      },\n                    },\n                  ]}\n                />\n              </FormRow>\n            ) : (\n              <FormRow>\n                <Label required>课程版权</Label>\n                <Dropdown\n                  name=\"courseRight\"\n                  options={[\n                    {\n                      value: 1,\n                      display: \'免费提供课程版权给课堂\',\n                    },\n                    {\n                      value: 2,\n                      display: \'不提供课程版权\',\n                    },\n                  ]}\n                  style={{ width: 200 }}\n                  data-required\n                  data-patterns={[]}\n                />\n              </FormRow>\n            )}\n            <FormRow>\n              <Label>课程有效期(使用传入的校验模式，表单联动)</Label>\n              <Dropdown\n                name=\"courseEndFlag\"\n                options={[\n                  {\n                    value: 1,\n                    display: \'课程截止时间\',\n                  },\n                  {\n                    value: 0,\n                    display: \'学习有效期\',\n                  },\n                ]}\n                style={{ width: 200 }}\n                onChange={this.handleFlagChange}\n                data-patterns={[\n                  {\n                    key: \'endFlag\',\n                  },\n                ]}\n              />\n              {this.state.hasEndTime ? (\n                <FormRow>\n                  <Label required>截止时间</Label>\n                  <Datepicker\n                    name=\"courseEndTime\"\n                    data-required\n                    data-patterns={[]}\n                  />\n                </FormRow>\n              ) : null}\n            </FormRow>\n            <Button disabled={!this.state.canSubmit}>提交</Button>\n          </Form>\n        </Validator>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              isFree: true,
              hasEndTime: 0,
              canSubmit: false
            };
            this.checkers = {
              endFlag: (val, callback) => {
                let isValid = true;
                let msg = '';

                if (!this.state.isFree && val === 0) {
                  isValid = false;
                  msg = '付费课必须选择课程截止日期';
                }

                callback({
                  isValid,
                  msg
                });
              }
            };
            this.handleTypeChange = this.handleTypeChange.bind(this);
            this.handleFlagChange = this.handleFlagChange.bind(this);
            this.toggleSubmit = this.toggleSubmit.bind(this);
          }

          handleTypeChange(val) {
            this.setState({
              isFree: val === 1
            }, () => {
              return val === 1 ? this.validator.checkField(undefined, 'courseRight') : this.validator.checkField(undefined, 'coursePrice');
            });
          }

          handleFlagChange(val) {
            this.setState({
              hasEndTime: val === 1
            }, () => {
              this.validator.checkField(undefined, 'courseEndTime');
            });
          }

          toggleSubmit(val) {
            this.setState({
              canSubmit: val
            });
          }

          render() {
            return <Validator ref={instance => {
              this.validator = instance;
            }} checkers={this.checkers} onValid={() => this.toggleSubmit(true)} onInValid={() => this.toggleSubmit(false)} mdxType="Validator">
            <Form horizontal={false} mdxType="Form">
            <FormRow mdxType="FormRow">
                <Label required mdxType="Label">课程名称(使用内置校验模式)</Label>
                <Input name="courseName" placeholder="1-10个字" data-required data-patterns={[{
                    key: 'limit',
                    msg: '须在1-10个字内',
                    limit: {
                      min: 1,
                      max: 10
                    }
                  }]} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
                <Label required mdxType="Label">课程类型(表单联动)</Label>
                <RadioGroup name="courseType" style={{
                    display: 'inline'
                  }} defaultValue={1} onChange={this.handleTypeChange} data-required data-patterns={[]} mdxType="RadioGroup">
                <Radio value={1} mdxType="Radio">免费</Radio>
                <Radio value={2} mdxType="Radio">收费</Radio>
                </RadioGroup>
            </FormRow>
            {!this.state.isFree ? <FormRow mdxType="FormRow">
                <Label required mdxType="Label">课程价格</Label>
                <Input name="coursePrice" placeholder="内置校验模式" data-required data-patterns={[{
                    key: 'range',
                    msg: '须在1-8000元之间',
                    range: {
                      min: 1,
                      max: 8000
                    }
                  }]} mdxType="Input" />
                </FormRow> : <FormRow mdxType="FormRow">
                <Label required mdxType="Label">课程版权</Label>
                <Dropdown name="courseRight" options={[{
                    value: 1,
                    display: '免费提供课程版权给课堂'
                  }, {
                    value: 2,
                    display: '不提供课程版权'
                  }]} style={{
                    width: 200
                  }} data-required data-patterns={[]} mdxType="Dropdown" />
                </FormRow>}
            <FormRow mdxType="FormRow">
                <Label mdxType="Label">课程有效期(使用传入的校验模式，表单联动)</Label>
                <Dropdown name="courseEndFlag" options={[{
                    value: 1,
                    display: '课程截止时间'
                  }, {
                    value: 0,
                    display: '学习有效期'
                  }]} style={{
                    width: 200
                  }} onChange={this.handleFlagChange} data-patterns={[{
                    key: 'endFlag'
                  }]} mdxType="Dropdown" />
                {this.state.hasEndTime ? <FormRow mdxType="FormRow">
                    <Label required mdxType="Label">截止时间</Label>
                    <Datepicker name="courseEndTime" data-required data-patterns={[]} mdxType="Datepicker" />
                </FormRow> : null}
            </FormRow>
            <Button disabled={!this.state.canSubmit} mdxType="Button">提交</Button>
            </Form>
        </Validator>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "msgalign"
    }}>{`msgAlign`}</h2>
    <Playground __position={2} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n    }\n    render() {\n      return (\n        <Validator msgAlign=\"bottom\">\n          <Form inline horizontal={false}>\n            <FormRow>\n              <Label>Email</Label>\n              <Input\n                placeholder={\'xxx@abc.com\'}\n                name=\"email\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'email\',\n                    msg: \'请输入邮箱地址\',\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label>Mobile</Label>\n              <Input\n                placeholder={\'11位数字\'}\n                name=\"mobile\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'mobile\',\n                    msg: \'请输入手机号码\',\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label>An Integer</Label>\n              <Input\n                placeholder={\'0\'}\n                name=\"integer\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'integer\',\n                    msg: \'必须是数字\',\n                  },\n                ]}\n              />\n            </FormRow>\n          </Form>\n          <br />\n          <Button>Submit</Button>\n        </Validator>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
          }

          render() {
            return <Validator msgAlign="bottom" mdxType="Validator">
            <Form inline horizontal={false} mdxType="Form">
            <FormRow mdxType="FormRow">
                <Label mdxType="Label">Email</Label>
                <Input placeholder={'xxx@abc.com'} name="email" data-required data-patterns={[{
                    key: 'email',
                    msg: '请输入邮箱地址'
                  }]} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
                <Label mdxType="Label">Mobile</Label>
                <Input placeholder={'11位数字'} name="mobile" data-required data-patterns={[{
                    key: 'mobile',
                    msg: '请输入手机号码'
                  }]} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
                <Label mdxType="Label">An Integer</Label>
                <Input placeholder={'0'} name="integer" data-required data-patterns={[{
                    key: 'integer',
                    msg: '必须是数字'
                  }]} mdxType="Input" />
            </FormRow>
            </Form>
            <br />
            <Button mdxType="Button">Submit</Button>
        </Validator>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "onvalid--oninvalid"
    }}>{`onValid / onInValid`}</h2>
    <Playground __position={3} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        canSubmit: false,\n      }\n      this.enableBtn = this.enableBtn.bind(this)\n      this.disableBtn = this.disableBtn.bind(this)\n      this.getFormValid = this.getFormValid.bind(this)\n    }\n    enableBtn() {\n      this.setState({ canSubmit: true })\n    }\n    disableBtn() {\n      this.setState({ canSubmit: false })\n    }\n    getFormValid() {\n      alert(this.refs.validator.isAllValid())\n    }\n    render() {\n      return (\n        <Validator\n          ref=\"validator\"\n          onValid={this.enableBtn}\n          onInValid={this.disableBtn}\n        >\n          <Form>\n            <FormRow>\n              <Label required>手机号</Label>\n              <Input\n                name=\"field1\"\n                placeholder=\"请填写您的手机号\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'mobile\',\n                    msg: \'格式不正确\',\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label>邮箱</Label>\n              <Input\n                name=\"field2\"\n                placeholder=\"请填写您的邮箱\"\n                data-patterns={[\n                  {\n                    key: \'email\',\n                    msg: \'格式不正确\',\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label>生日</Label>\n              <Datepicker name=\"field3\" data-patterns={[]} />\n            </FormRow>\n            <FormRow>\n              <Label required>性别</Label>\n              <RadioGroup name=\"field4\" data-required data-patterns={[]}>\n                <Radio value=\"0\">男</Radio>\n                <Radio value=\"1\">女</Radio>\n              </RadioGroup>\n            </FormRow>\n            <Button type=\"button\" disabled={!this.state.canSubmit}>\n              提交\n            </Button>\n            <Button type=\"button\" onClick={this.getFormValid}>\n              API: isAllValid()\n            </Button>\n          </Form>\n        </Validator>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              canSubmit: false
            };
            this.enableBtn = this.enableBtn.bind(this);
            this.disableBtn = this.disableBtn.bind(this);
            this.getFormValid = this.getFormValid.bind(this);
          }

          enableBtn() {
            this.setState({
              canSubmit: true
            });
          }

          disableBtn() {
            this.setState({
              canSubmit: false
            });
          }

          getFormValid() {
            alert(this.refs.validator.isAllValid());
          }

          render() {
            return <Validator ref="validator" onValid={this.enableBtn} onInValid={this.disableBtn} mdxType="Validator">
                <Form mdxType="Form">
                <FormRow mdxType="FormRow">
                    <Label required mdxType="Label">手机号</Label>
                    <Input name="field1" placeholder="请填写您的手机号" data-required data-patterns={[{
                    key: 'mobile',
                    msg: '格式不正确'
                  }]} mdxType="Input" />
                </FormRow>
                <FormRow mdxType="FormRow">
                    <Label mdxType="Label">邮箱</Label>
                    <Input name="field2" placeholder="请填写您的邮箱" data-patterns={[{
                    key: 'email',
                    msg: '格式不正确'
                  }]} mdxType="Input" />
                </FormRow>
                <FormRow mdxType="FormRow">
                    <Label mdxType="Label">生日</Label>
                    <Datepicker name="field3" data-patterns={[]} mdxType="Datepicker" />
                </FormRow>
                <FormRow mdxType="FormRow">
                    <Label required mdxType="Label">性别</Label>
                    <RadioGroup name="field4" data-required data-patterns={[]} mdxType="RadioGroup">
                    <Radio value="0" mdxType="Radio">男</Radio>
                    <Radio value="1" mdxType="Radio">女</Radio>
                    </RadioGroup>
                </FormRow>
                <Button type="button" disabled={!this.state.canSubmit} mdxType="Button">提交</Button>
                <Button type="button" onClick={this.getFormValid} mdxType="Button">API: isAllValid()</Button>
                </Form>
            </Validator>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "validator-apis-1"
    }}>{`Validator APIs`}</h2>
    <Playground __position={4} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.scroll = this.scroll.bind(this)\n      this.alertResult = this.alertResult.bind(this)\n      this.resetField = this.resetField.bind(this)\n    }\n    scroll() {\n      this.refs.validator.scrollToErrorField(0)\n    }\n    alertResult() {\n      alert(this.refs.validator.isFieldValid(\'field\'))\n    }\n    resetField() {\n      this.refs.validator.resetField(\'field\')\n    }\n    render() {\n      return (\n        <Validator ref=\"validator\">\n          <Input\n            name=\"field\"\n            placeholder=\"YYYY-MM-DD\"\n            data-required\n            data-patterns={[\n              {\n                key: \'date\',\n                msg: \'请输入日期\',\n              },\n            ]}\n          />\n          <br />\n          <Button onClick={this.scroll}>scrollToErrorField</Button>\n          <Button onClick={this.alertResult}>isFieldValid</Button>\n          <Button onClick={this.resetField}>resetField</Button>\n        </Validator>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.scroll = this.scroll.bind(this);
            this.alertResult = this.alertResult.bind(this);
            this.resetField = this.resetField.bind(this);
          }

          scroll() {
            this.refs.validator.scrollToErrorField(0);
          }

          alertResult() {
            alert(this.refs.validator.isFieldValid('field'));
          }

          resetField() {
            this.refs.validator.resetField('field');
          }

          render() {
            return <Validator ref="validator" mdxType="Validator">
                <Input name="field" placeholder="YYYY-MM-DD" data-required data-patterns={[{
                key: 'date',
                msg: '请输入日期'
              }]} mdxType="Input" />
                <br />
                <Button onClick={this.scroll} mdxType="Button">scrollToErrorField</Button>
                <Button onClick={this.alertResult} mdxType="Button">isFieldValid</Button>
                <Button onClick={this.resetField} mdxType="Button">resetField</Button>
            </Validator>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": ""
    }}></h2>
    <h1 {...{
      "id": "enhancer"
    }}>{`enhancer`}</h1>
    <h2 {...{
      "id": "prefix--suffix"
    }}>{`Prefix / Suffix`}</h2>
    <Playground __position={5} __code={'<Validator>\n  <Input\n    name=\"field\"\n    data-prefix=\"I am a prefix \"\n    data-suffix={<span> I am a suffix</span>}\n    data-required\n    data-patterns={[\n      {\n        key: \'email\',\n        msg: \'请输入邮箱地址\',\n      },\n    ]}\n  />\n</Validator>'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Validator mdxType="Validator">
        <Input name="field" data-prefix="I am a prefix " data-suffix={<span> I am a suffix</span>} data-required data-patterns={[{
          key: 'email',
          msg: '请输入邮箱地址'
        }]} mdxType="Input" />
    </Validator>
    </Playground>
    <h2 {...{
      "id": "默认提示：data-tips"
    }}>{`默认提示：data-tips`}</h2>
    <Playground __position={6} __code={'<Validator>\n  <Input\n    placeholder=\"Try data-tips\"\n    name=\"required-msg\"\n    data-required\n    data-tips=\"默认提示\"\n    data-patterns={[]}\n  />\n</Validator>'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Validator mdxType="Validator">
        <Input placeholder="Try data-tips" name="required-msg" data-required data-tips="默认提示" data-patterns={[]} mdxType="Input" />
    </Validator>
    </Playground>
    <h2 {...{
      "id": "自定义必填提示：data-required-msg"
    }}>{`自定义必填提示：data-required-msg`}</h2>
    <Playground __position={7} __code={'<Validator>\n  <Input\n    placeholder={\'Try data-required-msg\'}\n    name=\"data-tips\"\n    data-required\n    data-required-msg=\"该选项不能为空，请输入\"\n    data-patterns={[]}\n  />\n</Validator>'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Validator mdxType="Validator">
        <Input placeholder={'Try data-required-msg'} name="data-tips" data-required data-required-msg="该选项不能为空，请输入" data-patterns={[]} mdxType="Input" />
    </Validator>
    </Playground>
    <h2 {...{
      "id": "自定义提示信息位置-data-placer"
    }}>{`自定义提示信息位置: data-placer`}</h2>
    <Playground __position={8} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        msgEl: null,\n      }\n      this.showErrMsg = this.showErrMsg.bind(this)\n    }\n    showErrMsg(data) {\n      console.log(data)\n      this.setState({\n        msgEl: data.msgEl,\n      })\n    }\n    render() {\n      return (\n        <Validator>\n          <span> {this.state.msgEl}</span>\n          <Input\n            placeholder=\"Try data-placer\"\n            name=\"field2\"\n            data-required\n            data-placer={this.showErrMsg}\n            data-patterns={[\n              {\n                key: \'email\',\n                msg: \'请输入邮箱地址\',\n              },\n            ]}\n          />\n          <span> {this.state.msgEl}</span>\n        </Validator>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              msgEl: null
            };
            this.showErrMsg = this.showErrMsg.bind(this);
          }

          showErrMsg(data) {
            console.log(data);
            this.setState({
              msgEl: data.msgEl
            });
          }

          render() {
            return <Validator mdxType="Validator">
            <span> {this.state.msgEl}</span>
            <Input placeholder="Try data-placer" name="field2" data-required data-placer={this.showErrMsg} data-patterns={[{
                key: 'email',
                msg: '请输入邮箱地址'
              }]} mdxType="Input" />
            <span> {this.state.msgEl}</span>
        </Validator>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "自定义校验时机-data-trigger"
    }}>{`自定义校验时机: data-trigger`}</h2>
    <Playground __position={9} __code={'<Validator>\n  <Input\n    name=\"field\"\n    placeholder=\"onChange Trigger\"\n    data-required\n    data-trigger=\"onChange\"\n    data-patterns={[\n      {\n        key: \'email\',\n        msg: \'请输入邮箱地址\',\n      },\n    ]}\n  />\n  <div style={{ height: \'10px\' }}> </div>\n  <Input\n    name=\"field2\"\n    placeholder=\"onBlur Trigger\"\n    data-required\n    data-trigger=\"onBlur\"\n    data-patterns={[\n      {\n        key: \'email\',\n        msg: \'请输入邮箱地址\',\n      },\n    ]}\n  />\n</Validator>'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Validator mdxType="Validator">
        <Input name="field" placeholder="onChange Trigger" data-required data-trigger="onChange" data-patterns={[{
          key: 'email',
          msg: '请输入邮箱地址'
        }]} mdxType="Input" />
        <div style={{
          height: '10px'
        }}> </div>
        <Input name="field2" placeholder="onBlur Trigger" data-required data-trigger="onBlur" data-patterns={[{
          key: 'email',
          msg: '请输入邮箱地址'
        }]} mdxType="Input" />
    </Validator>
    </Playground>
    <h2 {...{
      "id": "check-on--off"
    }}>{`Check On / Off`}</h2>
    <Playground __position={10} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        isChecking: true,\n      }\n      this.toggleChecking = this.toggleChecking.bind(this)\n    }\n    toggleChecking() {\n      this.setState({\n        isChecking: !this.state.isChecking,\n      })\n    }\n    render() {\n      return (\n        <Validator>\n          <p> The check is {this.state.isChecking ? \'on\' : \'off\'} </p>\n          <Input\n            name=\"field\"\n            placeholder=\"Try data-checking\"\n            data-checking={this.state.isChecking}\n            data-patterns={[\n              {\n                key: \'limit\',\n                msg: \'须在5-50个字内\',\n                limit: {\n                  min: 5,\n                  max: 50,\n                },\n              },\n            ]}\n          />\n          <br />\n          <Button onClick={this.toggleChecking}>toggle校验</Button>\n        </Validator>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Validator,
      Form,
      FormRow,
      Label,
      Input,
      Radio,
      RadioGroup,
      Dropdown,
      Datepicker,
      Button,
      Message,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              isChecking: true
            };
            this.toggleChecking = this.toggleChecking.bind(this);
          }

          toggleChecking() {
            this.setState({
              isChecking: !this.state.isChecking
            });
          }

          render() {
            return <Validator mdxType="Validator">
            <p> The check is {this.state.isChecking ? 'on' : 'off'} </p>
            <Input name="field" placeholder="Try data-checking" data-checking={this.state.isChecking} data-patterns={[{
                key: 'limit',
                msg: '须在5-50个字内',
                limit: {
                  min: 5,
                  max: 50
                }
              }]} mdxType="Input" />
            <br />
            <Button onClick={this.toggleChecking} mdxType="Button">toggle校验</Button>
        </Validator>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      